var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form',{attrs:{"layout":"horizontal","label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"colon":false,"form":_vm.form}},[_c('a-row',[_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"required":"","label":"企业名称"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.chiName',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]),expression:"[\n            'registerAgentInfo.chiName',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ],\n              validateTrigger: 'blur'\n            }\n          ]"}],attrs:{"size":"large","placeholder":"请输入企业名称","disabled":_vm.type === 'modify'}})],1)],1),_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"required":"","label":"企业类型"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.agentType',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]),expression:"[\n            'registerAgentInfo.agentType',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ],\n              validateTrigger: 'blur'\n            }\n          ]"}],attrs:{"size":"large","placeholder":"请选择企业类型"}},[_c('a-select-option',{attrs:{"value":"AGENT"}},[_vm._v("旅行社")]),_c('a-select-option',{attrs:{"value":"TRAVEL"}},[_vm._v("代理人")]),_c('a-select-option',{attrs:{"value":"CORP"}},[_vm._v("机构客户")])],1)],1)],1)],1),_c('a-row',[_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"required":"","label":"业务员联系人"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.contactName',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]),expression:"[\n            'registerAgentInfo.contactName',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ],\n              validateTrigger: 'blur'\n            }\n          ]"}],attrs:{"size":"large","placeholder":"请输入业务员联系人姓名"}})],1)],1),_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"required":"","label":"所属营业部"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.department',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]),expression:"[\n            'registerAgentInfo.department',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ],\n              validateTrigger: 'blur'\n            }\n          ]"}],attrs:{"size":"large","placeholder":"请输入所属营业部"}})],1)],1)],1),_c('a-row',[_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"required":"","label":"OFFICE号"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.officeNo',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]),expression:"[\n            'registerAgentInfo.officeNo',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ],\n              validateTrigger: 'blur'\n            }\n          ]"}],attrs:{"size":"large","placeholder":"请输入航办office号"}})],1)],1),_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"label":"办公电话"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.phoneNo',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]),expression:"[\n            'registerAgentInfo.phoneNo',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ],\n              validateTrigger: 'blur'\n            }\n          ]"}],attrs:{"size":"large","placeholder":"请输入有效办公联系电话"}})],1)],1)],1),_c('a-row',[_c('a-col',{attrs:{"md":12,"sm":24}},[_c('a-form-item',{attrs:{"required":"","label":"国家/地区"}},[_c('a-cascader',{directives:[{name:"decorator",rawName:"v-decorator",value:([
            'registerAgentInfo.country',
            {
              rules: [
                {
                  validator: _vm.handleFieldValidate
                }
              ]
            }
          ]),expression:"[\n            'registerAgentInfo.country',\n            {\n              rules: [\n                {\n                  validator: handleFieldValidate\n                }\n              ]\n            }\n          ]"}],attrs:{"allow-clear":"","options":_vm.options,"load-data":_vm.loadData,"placeholder":"国家/省/市","change-on-select":"","size":"large"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }